import React, { Component } from 'react';
import PropTypes from "prop-types";
import "./WebNetRoiTable.css"

import { withTranslation } from 'react-i18next';

class WebNetRoiTable extends Component {    

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            disableDiv: false,
        }
    }

    async componentDidMount() { 
        const { rois, } = this.props;
        if (rois.length > 0) {
            this.setState({ loading: false, disableDiv: true }); 
        } else {
            this.setState({ divStyle: false });
        }
    }

    handleSelectedROI1 = (roiLabel, i) => {
        const { handleSelectedROI } = this.props;
        handleSelectedROI(roiLabel, i);
        //alert(roiLabel);
    }

    /*
     * Clear focused items
     * roiLabel = "-"
     * i = -1
    */
    handleMouseOut = (roiLabel, i) => {
        const { handleSelectedROI } = this.props;
        handleSelectedROI(roiLabel, i);
    }

    setClassName = (i) => {
        const { indexSelectedROI } = this.props;
        if (indexSelectedROI == 0 && i == 0) {
            return "rowHover"
        } else if (indexSelectedROI - i == 1 && indexSelectedROI % 2 !== 0) {
            return "bothDelta";
        } else {
            return "rowHover";
        }
    }

    convertTemp = (temp, isCelsius, isCelsiusImg) => {
        return isCelsius ? temp.toFixed(1) : Number(Math.round(temp * 1.8 + 32 + 'e1') + 'e-1').toFixed(1);
        
    }

    renderItemsTable(rois, t, isCelsius, isCelsiusImg) {
    return (
      <table className='table'>
        <thead>
          <tr>                 
            <th>{t("ROI-area")}</th>
            <th>{t("Center")}</th>
            <th>{t("Min")}</th>
            <th>{t("Max")}</th>
            <th>{t("Avg")}</th>
            <th>{t("Diff")}</th>
          </tr>
        </thead>
        <tbody>
                {rois.map((roi,i) =>                  
                    <tr key={roi.id} className={this.setClassName(i)} onMouseOver={() => this.handleSelectedROI1(roi.label, i)} onMouseOut={() => this.handleMouseOut("-", -1)} >
                    <td> {roi.label}</td>
                        <td>{this.convertTemp(roi.centertemp, isCelsius, isCelsiusImg)}</td>
                        <td>{this.convertTemp(roi.mintemp, isCelsius, isCelsiusImg)}</td>
                        <td>{this.convertTemp(roi.maxtemp, isCelsius, isCelsiusImg)}</td>
                        <td>{this.convertTemp(roi.avgtemp, isCelsius, isCelsiusImg)}</td>
                        <td>{roi.deltatemp && this.convertTemp(roi.deltatemp, isCelsius, isCelsiusImg)}</td>
                    </tr>
                )}
        </tbody>
      </table>
    );
  }

  render() {

      var divStyle = {
          display: this.state.disableDiv ? 'block' : 'none'
      };

      const { rois, t, isCelsius, isCelsiusImg } = this.props;

      let contents = this.state.loading 
          ? <p><em>{t("Loading...")}</em></p>
          : this.renderItemsTable(rois, t, isCelsius, isCelsiusImg);

    return (
        <div style={divStyle}>
        {contents}
      </div>
    );
  }
}

export default withTranslation()(WebNetRoiTable);

WebNetRoiTable.propTypes = {


}